"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on 26.11.2018
 */

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * Converts supplier site bindings
 * @author ZSr
 */


var SupplierSiteBindingConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(SupplierSiteBindingConverter, _DataObjectConverter_);

  function SupplierSiteBindingConverter() {
    _classCallCheck(this, SupplierSiteBindingConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SupplierSiteBindingConverter).apply(this, arguments));
  }

  return SupplierSiteBindingConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.SupplierSiteBindingConverter = SupplierSiteBindingConverter;